import MarkdownIt from 'markdown-it';
import {parseDocument} from 'htmlparser2';

const markdown = new MarkdownIt({html: true, breaks: true, linkify: true});

export type ResponseNode = ReturnType<typeof parseDocument>['children'][number];

// Only unwrap a complete HTML document fence. Other code fences stay literal.
export function parseResponse(content: string): ResponseNode[] {
  const htmlFence = content.trim().match(/^```html\s*\n([\s\S]*?)\n```$/i);
  return parseDocument(markdown.render(htmlFence ? htmlFence[1] : content)).children;
}

export function safeResponseUrl(url: string): string | undefined {
  const trimmed = url.trim();
  return /^(https?:\/\/|mailto:)/i.test(trimmed) && !/[\u0000-\u0020\u007f]/.test(trimmed)
    ? trimmed : undefined;
}

export function responseText(node: ResponseNode): string {
  if (node.type === 'text') return node.data;
  if ('children' in node) return node.children.map(responseText).join('');
  return '';
}
